import { REQUEST_ERROR_HIDE, REQUEST_USER_DATA } from '../constants';

export const hideRequestError = () => dispatch => {
  dispatch({ type: REQUEST_ERROR_HIDE });
};

export const retryGetUserData = () => dispatch => {
  dispatch({ type: REQUEST_USER_DATA });
};
